<script setup lang="ts">
import { computed } from 'vue';
import { type LocationQueryRaw, type RouteParamsGeneric, useRoute } from 'vue-router';

export type BreadcrumbLinkItem = {
  label: string;
  to?: {
    name: string;
    params?: RouteParamsGeneric;
    query?: LocationQueryRaw;
  };
};

const { item } = defineProps<{
  /**
   * The item to display in the breadcrumb.
   */
  item: BreadcrumbLinkItem;
}>();

const route = useRoute();
const isCurrentRoute = (to: string) => {
  if (typeof to === 'string') {
    return route.name === to || route.path === to;
  }

  return false;
};

const to = computed(() => {
  return {
    name: item.to.name,
    params: item.to.params,
    query: item.to.query,
  };
});
</script>

<template>
  <!-- render static breadcrumb item -->
  <li v-if="item.to == null || isCurrentRoute(item.to.name)" class="tw-font-bold tw-text-gp-mouse">
    {{ item.label }}
  </li>

  <template v-else>
    <li>
      <router-link :to="to">
        {{ item.label }}
      </router-link>
    </li>
    <li class="tw-text-gp-rhino">
      <slot name="divider"> / </slot>
    </li>
  </template>
</template>
